// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.common-distributor-search .selected-member-container .each-member .info-container {
  font-family: "72-Regular";
}

.common-distributor-search .memeber-dtls .circle-divider {
  margin-left: 0.2rem;
}
.common-distributor-search .cald_predictive-search-name {
  text-align: left;
  word-break: break-word;
}
.common-distributor-search .distributor-header {
  margin-top: 1rem;
  margin-bottom: 0.3rem;
}
.common-distributor-search .dsPro_search-box {
  margin: 0;
}
.common-distributor-search .side-margin-left {
  margin: 2rem 1rem 0rem 1rem;
}
.common-distributor-search .cald_predictive-search-highlighter:before {
  border: #f3bc44 1px solid;
}
.common-distributor-search .selected-member-container {
  position: static;
  background-color: #ffffff;
  list-style-type: none;
  box-shadow: none;
  overflow: auto;
  width: 100%;
}
.common-distributor-search .selected-member-container .each-member {
  padding: 0rem 1rem;
}
.common-distributor-search .selected-member-container .each-member:hover {
  background-color: #fff;
}
.common-distributor-search .selected-member-container .each-member .info-container {
  font-size: 1.2rem;
  text-align: left;
  color: #2797df;
}
.common-distributor-search .selected-member-container .each-member .info-container .cancel-btn {
  text-decoration: none;
  font-size: 1.2rem;
}
.common-distributor-search .selected-member-container .each-member .info-container .name {
  text-overflow: ellipsis;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/distributor-search/distributor-search.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AACI;EACE,mBAAA;AAEN;AACE;EACE,gBAAA;EACA,sBAAA;AACJ;AACE;EACI,gBAAA;EACA,qBAAA;AACN;AACE;EACE,SAAA;AACJ;AACE;EACE,2BAAA;AACJ;AACE;EACE,yBAAA;AACJ;AACE;EACE,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AACJ;AAAI;EACE,kBAAA;AAEN;AADM;EACE,sBAAA;AAGR;AADM;EAEE,iBAAA;EACA,gBAAA;EACA,cAAA;AAER;AADQ;EACE,qBAAA;EACA,iBAAA;AAGV;AADQ;EACE,uBAAA;EACA,gBAAA;AAGV","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n.common-distributor-search{\n  // margin-left: -0.5rem;\n  .memeber-dtls{\n    .circle-divider{\n      margin-left: 0.2rem;\n    }\n  }\n  .cald_predictive-search-name{\n    text-align: left;\n    word-break: break-word;\n  }\n  .distributor-header {\n      margin-top: 1rem;\n      margin-bottom: 0.3rem;\n  }\n  .dsPro_search-box {\n    margin: 0;\n  }\n  .side-margin-left {\n    margin: 2rem 1rem 0rem 1rem;\n  }\n  .cald_predictive-search-highlighter:before{\n    border: #f3bc44 1px solid;\n  }\n  .selected-member-container{\n    position: static;\n    background-color: #ffffff;\n    list-style-type: none;\n    box-shadow: none;\n    overflow: auto;\n    width: 100%;\n    .each-member{\n      padding: 0rem 1rem;\n      &:hover{\n        background-color: #fff;\n      }\n      .info-container{\n        @extend %font-regular;\n        font-size: 1.2rem;\n        text-align: left;\n        color: #2797df;\n        .cancel-btn{\n          text-decoration: none;\n          font-size: 1.2rem;\n        }\n        .name{\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
